import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Button, Alert, ActionRow, ModalDialog } from '@openedx/paragon';
import BaseContainer from '../base-container';
import { loginRequest } from '../login/data/actions';
import { getConfig } from '@edx/frontend-platform';
import messages from './messages'; // make sure you have translations
import { useIntl } from '@edx/frontend-platform/i18n';

const OtpVerify = () => {
  const [otp, setOtp] = useState('');
  const { formatMessage } = useIntl();
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [disabling, setDisabling] = useState(false);
  const [showAlert, setShowAlert] = useState(true);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const credentials = location.state?.credentials;
  const loginResult = useSelector(state => state.login.loginResult);
  const platformName = getConfig().SITE_NAME;

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowAlert(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (loginResult && loginResult.success) {
      window.location.href = loginResult.redirectUrl || '/authn/login';
    } else if (loginResult && loginResult.error) {
      setError(loginResult.error);
    }
  }, [loginResult, navigate]);

  const handleSubmit = async (e) => {
    setDisabling(true);
    e.preventDefault();
    setError('');
    if (!credentials) {
      setDisabling(false);
      setError('Missing credentials. Please try again.');
      return;
    }

    const response = await fetch(`${getConfig().LMS_BASE_URL}/api/verify_otp`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({identifier: credentials.emailOrUsername, otp: otp}),
    });

    const data = await response.json();

    if (!response.ok) {
      setDisabling(false);
      setError(data.error || 'Verification failed. Try again.');
      return;
    }
    // setShowModal(true);
    const payload = {
      email_or_username: credentials.emailOrUsername,
      password: credentials.password,
      otp,
    };
    dispatch(loginRequest(payload));
  };

  const handleContinue = () => {
    if (!credentials) {
      setError('Missing credentials. Please try again.');
      return;
    }
    // Prepare payload for loginRequest
    const payload = {
      email_or_username: credentials.emailOrUsername,
      password: credentials.password,
      otp,
    };
    dispatch(loginRequest(payload));
  };

  const handleResendOTP = async (e) => {
    e.preventDefault();
    setError('');
    if (!credentials) {
      setError('Missing credentials. Please try again.');
      return;
    }

    const response = await fetch(`${getConfig().LMS_BASE_URL}/api/resend_otp`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({identifier: credentials.emailOrUsername}),
    });

    const data = await response.json();

    if (!response.ok) {
      setShowAlert(true);
      setError(data.error || 'Resend Verification OTP failed. Try again.');
      return;
    }
    setShowSuccessAlert(true);
    setTimeout(() => setShowSuccessAlert(false), 5000);
  };

  return (
    <BaseContainer>
      <div className="d-flex flex-column align-items-center justify-content-center w-100" style={{ minHeight: '60vh' }}>
        <div className="auth-card p-4" style={{ maxWidth: 400, width: '100%' }}>
          <h2 className="mb-4 text-center">OTP Verification</h2>
          {showAlert && <Alert variant="success"><span>Check your email </span><a href="#" onClick={handleResendOTP}> Resend Code</a></Alert>}
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="otp">
              <Form.Label>Enter OTP</Form.Label>
              <Form.Control
                type="text"
                value={otp}
                onChange={e => setOtp(e.target.value)}
                maxLength={6}
                required
                autoFocus
              />
            </Form.Group>
            {error && <Alert variant="danger">{error}</Alert>}
            {showSuccessAlert && <Alert variant="success">OTP sent successfully!</Alert>}
            <Button type="submit" variant="primary" disabled={disabling} className="w-100 mt-3">Verify</Button>
          </Form>
        </div>
      </div>
       {/* ✅ Modal shown after OTP success */}
      {showModal && (
        <ModalDialog
          title={formatMessage(messages['modal.title'])}
          isOpen={showModal}
          onClose={() => {}}
          size="sm"
          variant="default"
          hasCloseButton={false}
        >
          <ModalDialog.Header>
            <ModalDialog.Title>
              {formatMessage(messages['modal.title'])}
            </ModalDialog.Title>
          </ModalDialog.Header>

          <ModalDialog.Body>
            {formatMessage(messages['modal.description'])}
          </ModalDialog.Body>

          <ModalDialog.Footer>
            <ActionRow>
              <Button onClick={handleContinue} variant="primary">
                {formatMessage(messages['continue.to.platform'], { platformName })}
              </Button>
            </ActionRow>
          </ModalDialog.Footer>
        </ModalDialog>
      )}
    </BaseContainer>
  );
};

export default OtpVerify;
